export const size = {
  tablet: 825,
  mobile: 670,
};

export const device = {
  tablet: `(max-width: ${size.tablet}px)`,
  mobile: `(max-width: ${size.mobile}px)`,
};
